<script>
import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import AnketYanitlarSingle from "./AnketYanitlarSingle.vue";
import Drawer from "vue-simple-drawer";

export default {
  mixins: [Api, Sabit],
  props: ["Data"],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Drawer,AnketYanitlarSingle },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],
      AnktAnketId: this.$route.params.AnktAnketId,
      FormData: [],
      FormJson: [],
      FilitrelemePenceresi: false,
      AnketFilter:{},
      AnketFilterText:""
    };
  },
  methods: {
    Get() {},
    FilterDuzenleme(){ 
      this.AnketFilterText = ""
      for(var filter in this.AnketFilter){ 
        if(this.AnketFilter[filter]){
        this.AnketFilterText += "and cevap->'" + filter + "' ->> 'Cevap' ='" + this.AnketFilter[filter] + "'"
        }
      } 
    }
    ,
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
  created() {
    this.ActionsSingleGet({
      Service: "AnktAnket",
      Id: this.AnktAnketId,
    }).then((res) => {
      this.FormData = res.Data;
      this.FormJson = JSON.parse(this.FormData.Anketjson); 
        for(var Bolumler in this.FormJson){ 
            for(var Form in this.FormJson[Bolumler].FormFiled){
              if(this.FormJson[Bolumler].FormFiled[Form].type =='combobox' ||
              this.FormJson[Bolumler].FormFiled[Form].type =='radiobutton'
              ){
              this.AnketFilter.[this.FormJson[Bolumler].FormFiled[Form].Id]=""
              }
            }
        }
    });
  },
};
</script>
<style>
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}
</style>
<template>
  <div v-if="FormJson">
    <div role="tablist">
      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("AnktAnket.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("AnktAnket.Filtreleme.Content") }}

            <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex">
              <template v-for="(Form, index) in Bolumler.FormFiled">
                <b-form-group
                  :key="index"
                  :label="Form.props.title"
                  label-for="text"
                  class="mt-3"
                    v-if="Form.type == 'combobox' || Form.type == 'radiobutton'"
                >
                  <select
                    class="form-select"
                    type="text"
                    v-model="AnketFilter[Form.Id]"
                  >
                    <option value="">Seçiniz</option>
                    <option
                      v-for="options in Form.options"
                      :key="options.Id"
                      :value="options.Id"
                    >
                      {{ options.value }}
                    </option>
                  </select>
                </b-form-group></template
              >
            </div>

            <b-button
              @click="FilterDuzenleme()"
              class="btn btn-primary mt-3"
              variant="primary"
            >
              {{ $t("AnktAnket.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>

      <div v-for="(Bolumler, Bolumindex) in FormJson" :key="Bolumindex">
        <div class="text-sm-end" v-if="Object.keys(AnketFilter).length > 0">
          <button
            type="button"
            class="btn btn-secondary btn-rounded mb-2 me-2"
            @click="rightDrawer()"
          >
            <i class="mdi mdi-text-search me-1"></i>
            {{ $t("AnktAnket.Page.Filtreleme") }}
          </button>
        </div>

        <b-card no-body class="mb-1 shadow-none">
          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a
                v-b-toggle="'accordion-' + Bolumindex"
                class="text-dark"
                href="javascript: void(0);"
              >
                <i :class="Bolumler.FormIcon"></i>
                {{ Bolumler.FormTitle }} <i class="bx bx-down-arrow-alt"></i>
              </a>
            </h6>
          </b-card-header>
          <b-collapse
            :id="'accordion-' + Bolumindex"
            visible
            accordion="my-accordion"
            role="tabpanel"
          >
            <b-card-body>
              <b-card-text>
                <div class="text-sm-end">
                  {{ $t("CreateAnket.AddEdit.Bolum") }}
                  {{ Bolumindex + 1 }} / {{ FormJson.length }}
                </div>

                <div v-for="(Form, index) in Bolumler.FormFiled" :key="index">
                  <AnketYanitlarSingle
                    :Form="Form"
                    :AnktAnketId="AnktAnketId"
                    :AnketFilterText="AnketFilterText"
                  />
                  <hr />
                </div>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>

        <!-- <b-card bg-variant="primary" class="text-white-50">
          <div class="row">
            <div class="col-4">
              <h5 class="mt-0 mb-1 text-white">
                <i :class="Bolumler.FormIcon"></i>
                {{ Bolumler.FormTitle }}
              </h5>
            </div>
            <div class="col-8">
              <h5 class="mt-0 mb-1 text-white">
                <div class="text-sm-end">
                  {{ $t("CreateAnket.AddEdit.Bolum") }}
                  {{ Bolumindex + 1 }} / {{ FormJson.length }}
                </div>
              </h5>
            </div>
          </div></b-card
        >
        <div v-for="(Form, index) in Bolumler.FormFiled" :key="index">
          <AnketYanitlarSingle :Form="Form" :AnktAnketId="AnktAnketId" />
          <hr />
        </div> -->
      </div>
    </div>
  </div>
</template>
